import { RadioButton } from '@msc-b2c/shared-components';

import styles from './radiogroup.module.scss';

export default function RadioGroup({
  name,
  options,
  selectedValue,
  onChange,
}: {
  name: string;
  options: Array<{ label: string; value: string; disabled?: boolean }>;
  selectedValue: string | undefined;
  onChange: (value: string) => void;
}) {
  return (
    <div className={styles['drawer-radio-group']}>
      {options.map((option) => (
        <div
          className={styles['drawer-radio-group__option']}
          key={option.value}
        >
          <RadioButton
            key={option.value}
            name={name}
            text={option.label}
            checked={selectedValue === option.value}
            onChange={() => onChange(option.value)}
            disabled={option.disabled}
          />
        </div>
      ))}
    </div>
  );
}
